import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header {
  s3BaseUrl = environment.s3BaseUrl;
  
  // Estado del menú móvil
  isMobileMenuOpen = false;

  // Menú de navegación
  menuItems = [
    { text: 'Home', link: '#home' },
    { text: 'Proyecto', link: '#proyecto' },
    { text: 'Mapa Interactivo', link: '#mapa' },
    { text: 'Beneficios', link: '#beneficios' },
    { text: 'Contacto', link: '#contacto' }
  ];

  constructor() {
    console.log('Header component loaded!', this.menuItems);
  }

  // scroll a las secciones
  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      // Scroll suave con offset para el header fijo
      const headerHeight = 80; // Altura aproximada del header
      const elementPosition = element.offsetTop - headerHeight;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  }

  // Toggle del menú móvil
  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  // Cerrar menú móvil
  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }

  getImageUrl(path: string): string {
    return `${this.s3BaseUrl}/${path}`;
  }
}
